import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import info from "../../../assets/popups/info.svg";
import downlaod from "../../../assets/popups/downloadLogo.svg";
import "./bulk-upload.css";
import { useDispatch } from "react-redux";
import {
  distributorCsvUpload,
  doctorCsvUpload,
  fieldForceCsvUpload,
  pharmacyCsvUpload,
  productCsvUpload,
} from "../../../redux/actions/divisionAction";
import ProductDataVerificationModal from "./productDataVerification";
import FieldForceDataVerificationModal from "./field-force-verification-modal";
import DistributorDataVerificationModal from "./distributor-verification-modal";
import DoctorDataVerificationModal from "./doctor-verification-table";
import PharmacyDataVerificationModal from "./PharmacyVerificationModal";

const BulkUploadModal = ({ show, ShowClose, DivisionData }) => {
  const dispatch = useDispatch();
  const [showProductDetailModal, setShowProductDetailModal] = useState(false); // PRODUCT BULK UPLOAD
  const [productData, setProductData] = useState(null); // PRODUCT BULK UPLOAD
  const [fieldForceData, setFieldForceData] = useState(null); // FF BULK UPLOAD
  const [showFieldForceModal, setFieldForceModal] = useState(false); // FF BULK UPLOAD
  const [showDistributorModal, setShowDistributorModal] = useState(false); // DISTRIBUTOR BULK UPLOAD
  const [distributorData, setDistributorData] = useState(null); // DISTRIBUTOR BULK UPLOAD
  const [showDoctorModal, setshowDoctorModal] = useState(false); // DOCTOR BULK UPLOAD
  const [doctorData, setDoctorData] = useState(null); // DOCTOR BULK UPLOAD
  const [showPharmacyModal, setShowPharmacyModal] = useState(false); // PHARMACY BULK UPLOAD
  const [pharmacyData, setPharmacyData] = useState(null); // PHARMACY BULK UPLOAD

  // -------- PRODUCT BULK UPLOAD --------
  const productHandleChange = (file) => {
    dispatch(
      productCsvUpload(
        { division_id: DivisionData },
        file,
        onCSVProductUploadSuccess,
        onCSVProductUploadError
      )
    );
  };
  const onCSVProductUploadSuccess = (data) => {
    console.log(data);
    ShowClose();
    setShowProductDetailModal(true);
    setProductData(data.data.data);
  };
  const onCSVProductUploadError = (err) => {
    console.log(err);
  };

  // -------- FIELD FORCE BULK UPLOAD --------
  const ffHandleChange = (file) => {
    dispatch(
      fieldForceCsvUpload(
        { division_id: DivisionData },
        file,
        onCSVFieldForceUploadSuccess,
        onCSVFieldForceUploadError
      )
    );
  };
  const onCSVFieldForceUploadSuccess = (data) => {
    console.log(data);
    ShowClose();
    setFieldForceModal(true);
    setFieldForceData(data.data.data);
  };
  const onCSVFieldForceUploadError = (err) => {
    console.log(err);
  };

  // -------- DISTRIBUTOR BULK UPLOAD --------
  const distributorHandleChange = (file) => {
    dispatch(
      distributorCsvUpload(
        { division_id: DivisionData },
        file,
        onCSVDistributorUploadSuccess,
        onCSVDistributorUploadError
      )
    );
  };
  const onCSVDistributorUploadSuccess = (data) => {
    console.log(data);
    ShowClose();
    setShowDistributorModal(true);
    setDistributorData(data.data.data);
  };
  const onCSVDistributorUploadError = (err) => {
    console.log(err);
  };

  // -------- DOCTOR BULK UPLOAD --------
  const doctorHandleChange = (file) => {
    dispatch(
      doctorCsvUpload(
        { division_id: DivisionData },
        file,
        onCSVDoctorUploadSuccess,
        onCSVDoctorUploadError
      )
    );
  };
  const onCSVDoctorUploadSuccess = (data) => {
    console.log(data);
    ShowClose();
    setshowDoctorModal(true);
    setDoctorData(data.data.data);
  };
  const onCSVDoctorUploadError = (err) => {
    console.log(err);
  };

  // -------- PHARMACY BULK UPLOAD --------
  const pharmacyHandleChange = (file) => {
    dispatch(
      pharmacyCsvUpload(
        { division_id: DivisionData },
        file,
        onPharmacyUploadSuccess,
        onPharmacyUploadError
      )
    );
  };
  const onPharmacyUploadSuccess = (data) => {
    console.log(data.data.data);
    ShowClose();
    setShowPharmacyModal(true);
    setPharmacyData(data.data.data);
  };
  const onPharmacyUploadError = (err) => {
    console.log(err);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        contentClassName="bulk-modal col-8 mx-auto p-2 fn_Nunito"
        size="lg"
      >
        <ModalHeader className="fw_600 fs_18">Upload Bulk Data</ModalHeader>
        <ModalBody>
          <div className="">
            <div className="data-upload-container justify-content-between my-3 mx-auto px-2 w-100 d-flex align-items-center">
              <div className="w-100" style={{ maxWidth: "250px" }}>
                <label className="fw_600 fs_16">Product Data</label>
              </div>
              <div className="d-flex gap-2">
                <div
                  style={{ backgroundColor: "#D4FAFF", borderRadius: "5px" }}
                  className="d-flex align-items-center fs_15 p-1 px-2"
                >
                  <img src={info} />
                  <span className="fw_600 ms-1">Download Sample</span>
                  <button
                    style={{ border: "none", backgroundColor: "#D4FAFF" }}
                  >
                    <a
                      href="https://jivini-live.s3.ap-south-1.amazonaws.com/Product-Data.csv"
                      target="_blank"
                    >
                      <img src={downlaod} />
                    </a>
                  </button>
                </div>
                <label className="upload-btn text-white px-4 fs_16 ">
                  Upload
                  <input
                    className="upload-document-input"
                    type="file"
                    accept=".csv"
                    onChange={(e) => productHandleChange(e.target.files[0])}
                    onClick={(e) => (e.target.value = null)}
                  />
                </label>
              </div>
            </div>

            <div className="data-upload-container justify-content-between my-3 mx-auto px-2 w-100 d-flex align-items-center">
              <div className="w-100" style={{ maxWidth: "250px" }}>
                <label className="fw_600 fs_16 w-100">
                  Field Force User Data
                </label>
              </div>
              <div className="d-flex gap-2">
                <div
                  style={{ backgroundColor: "#D4FAFF", borderRadius: "5px" }}
                  className="d-flex align-items-center fs_15 p-1 px-2 text-nowrap"
                >
                  <img src={info} />
                  <span className="fw_600 ms-1">Download Sample</span>
                  <button
                    style={{ border: "none", backgroundColor: "#D4FAFF" }}
                  >
                    <a
                      href="https://jivini-live.s3.ap-south-1.amazonaws.com/Fieldforce-Data-Upload.csv"
                      target="_blank"
                    >
                      <img src={downlaod} />
                    </a>
                  </button>
                </div>

                <label className="upload-btn text-white px-4 fs_16 ">
                  Upload
                  <input
                    className="upload-document-input"
                    type="file"
                    accept=".csv"
                    onChange={(e) => ffHandleChange(e.target.files[0])}
                    onClick={(e) => (e.target.value = null)}
                  />
                </label>
              </div>
            </div>

            <div className="data-upload-container justify-content-between my-3 mx-auto px-2 w-100 d-flex align-items-center">
              <div className="w-100" style={{ maxWidth: "250px" }}>
                <label className="fw_600 fs_16 w-100">Distributor Data</label>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <div
                  style={{ backgroundColor: "#D4FAFF", borderRadius: "5px" }}
                  className="d-flex align-items-center fs_15 p-1 px-2"
                >
                  <img src={info} />
                  <span className="fw_600 ms-1">Download Sample</span>
                  <button
                    style={{ border: "none", backgroundColor: "#D4FAFF" }}
                  >
                    <a
                      href="https://jivini-live.s3.ap-south-1.amazonaws.com/Distributor-Data-Upload.csv"
                      target="_blank"
                    >
                      <img src={downlaod} />
                    </a>
                  </button>
                </div>
                <label className="upload-btn text-white px-4 fs_16 ">
                  Upload
                  <input
                    className="upload-document-input"
                    type="file"
                    onChange={(e) => distributorHandleChange(e.target.files[0])}
                    onClick={(e) => (e.target.value = null)}
                    accept=".csv"
                  />
                </label>
              </div>
            </div>

            <div className="data-upload-container justify-content-between my-3 mx-auto px-2 w-100 d-flex align-items-center">
              <div className="w-100" style={{ maxWidth: "250px" }}>
                <label className="fw_600 fs_16 w-100">Doctor Data</label>
              </div>
              <div className="d-flex gap-2">
                <div
                  style={{ backgroundColor: "#D4FAFF", borderRadius: "5px" }}
                  className="d-flex align-items-center fs_15 p-1 px-2"
                >
                  <img src={info} />
                  <span className="fw_600 ms-1">Download Sample</span>
                  <button
                    style={{ border: "none", backgroundColor: "#D4FAFF" }}
                  >
                    <a
                      href="https://jivini-live.s3.ap-south-1.amazonaws.com/Doctor-Data-Upload.csv"
                      target="_blank"
                    >
                      <img src={downlaod} />
                    </a>
                  </button>
                </div>
                <label className="upload-btn text-white px-4 fs_16 ">
                  Upload
                  <input
                    className="upload-document-input"
                    type="file"
                    onChange={(e) => doctorHandleChange(e.target.files[0])}
                    onClick={(e) => (e.target.value = null)}
                    accept=".csv"
                  />
                </label>
              </div>
            </div>
            <div className="data-upload-container justify-content-between my-3 mx-auto px-2 w-100 d-flex align-items-center">
              <div className="w-100" style={{ maxWidth: "250px" }}>
                <label className="fw_600 fs_16 w-100">Pharmacy Data</label>
              </div>
              <div className="d-flex gap-2">
                <div
                  style={{ backgroundColor: "#D4FAFF", borderRadius: "5px" }}
                  className="d-flex align-items-center fs_15 p-1 px-2"
                >
                  <img src={info} />
                  <span className="fw_600 ms-1">Download Sample</span>
                  <button
                    style={{ border: "none", backgroundColor: "#D4FAFF" }}
                  >
                    <a
                      href="https://jivini-live.s3.ap-south-1.amazonaws.com/Pharmacy-Data-Upload.csv"
                      target="_blank"
                    >
                      <img src={downlaod} />
                    </a>
                  </button>
                </div>
                <label className="upload-btn text-white px-4 fs_16 ">
                  Upload
                  <input
                    className="upload-document-input"
                    type="file"
                    onChange={(e) => pharmacyHandleChange(e.target.files[0])}
                    onClick={(e) => (e.target.value = null)}
                    accept=".csv"
                  />
                </label>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ProductDataVerificationModal
        show={showProductDetailModal}
        division_id={DivisionData}
        productData={productData}
        ShowClose={() => setShowProductDetailModal(false)}
      />
      <FieldForceDataVerificationModal
        show={showFieldForceModal}
        division_id={DivisionData}
        fieldForceData={fieldForceData}
        ShowClose={() => setFieldForceModal(false)}
      />
      <DistributorDataVerificationModal
        show={showDistributorModal}
        division_id={DivisionData}
        distributorData={distributorData}
        ShowClose={() => setShowDistributorModal(false)}
      />
      <DoctorDataVerificationModal
        show={showDoctorModal}
        division_id={DivisionData}
        doctorData={doctorData}
        ShowClose={() => setshowDoctorModal(false)}
      />
      <PharmacyDataVerificationModal
        division_id={DivisionData}
        show={showPharmacyModal}
        ShowClose={() => setShowPharmacyModal(false)}
        pharmacyData={pharmacyData}
      />
    </>
  );
};

export default BulkUploadModal;
